module.exports = __webpack_public_path__ + "img/terracenew_box23.2eb8ecd6.jpg";